module.exports = __webpack_public_path__ + "static/media/pdf.f74ec69b.png";